export async function updateThemeData({ payload, token }) {
  const resp = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/updateMultiple`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    }
  );

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    const message = err.message || err.error || err.msg || (typeof err === "string" ? err : null) || `Failed to update admin settings (${resp.status})`;
    throw new Error(message);
  }

  return resp.json();
}